//
// Generated class PaymentInstallmentAccountingEntry
//

/// <reference path="PaymentInstallmentAccountingEntry_ManagedObject.ts" />

class PaymentInstallmentAccountingEntry extends PaymentInstallmentAccountingEntry_ManagedObject
{

}
